document.addEventListener('DOMContentLoaded', function() {
    // Function to check for the select element
    function checkSelectElement() {
        // Select the element by name attribute
        var selectElement = document.querySelector('select[name="options[Series]"]');
        
        // Check if the element exists
        if (selectElement) {
            // Log and convert the initial value to lowercase
            var initialValue = selectElement.value.toLowerCase();
            // Show the matching series-copy div
            showSeriesCopyDiv(initialValue);

            // Add an event listener for changes
            selectElement.addEventListener('change', function() {
                // Log and convert the changed value to lowercase
                var changedValue = selectElement.value.toLowerCase();

                // Show the matching series-copy div
                showSeriesCopyDiv(changedValue);
            });
        }
    }

    // Function to show the matching series-copy div
    function showSeriesCopyDiv(seriesValue) {
        // Select all series-copy divs
        var seriesDivs = document.querySelectorAll('.series-copy');
        
        // Loop through all series-copy divs
        seriesDivs.forEach(function(div) {
            // Check if the div's class includes the series value
            if (div.classList.contains(seriesValue)) {
                div.style.display = 'block'; // Show the matching div
            } else {
                div.style.display = 'none'; // Hide non-matching divs
            }
        });
    }

    // Run the check function
    checkSelectElement();
});